import { areDisplayAdsEnabled } from './adsUtilities';
import {
    getAdMarketPublishGroupCode,
    getMarketCountryCode,
    getMarketParts,
    getMuidCookie,
    getToptOutCookie,
    supportedMarkets,
    getAstScriptUrl,
} from './sharedAdsUtils';
import {
    getNativeAdInitialProviderForUser,
    getNativeAdInitialPlacement,
    BING_SUPPORTED_MARKETS,
} from './nativeAdsUtils';

export {
    getAdMarketPublishGroupCode,
    getMarketCountryCode,
    getMarketParts,
    getMuidCookie,
    getToptOutCookie,
    areDisplayAdsEnabled,
    getNativeAdInitialProviderForUser,
    getNativeAdInitialPlacement,
    supportedMarkets,
    getAstScriptUrl,
    BING_SUPPORTED_MARKETS,
};

export { default as NativeAdInitialProvider } from './NativeAdInitialProvider';
export { default as NativeAdPlacement } from './NativeAdPlacement';
export { default as isGdprAdMarket } from './isGdprAdMarket';
export { default as areAdsEnabled } from './areAdsEnabled';

export { loadScript } from './loadScript';
